<div mat-dialog-content>
    <div class="mat-dialog-content">
        <div class="head-origin-group-modal">
            <h2>Deseja excluir o Grupo de procedência?</h2>
         </div>
         
         <div class="body-origin-group-modal">
            Você realmente deseja excluir este Grupo de procedência? Se sim todas os tipos de chegada e origem serão desvinculados.
         </div>
         <div class="footer-origin-group-modal">
            <button mat-flat-button color="primary" class="btn-primary btn-block" (click)="clickDelete()">
                <span *ngIf="isLoading == false">Sim, excluir</span>
                <mat-spinner [diameter]="30" class="mat-spinner-btn" *ngIf="isLoading == true"></mat-spinner>
            </button>
            <button mat-flat-button color="accent" class="btn-secundary btn-block"(click)="clickCancel()">Cancelar</button>
        </div>
    </div>
</div>